import { DeleteOutlined } from "@ant-design/icons";
import { Button, Select, Upload } from "antd";
import { size } from "lodash";
import { useCallback, useEffect, useState } from "react";
import allImgPaths from "../../assets";
import CustomTable from "../../components/common/CustomTable";
import Layout, { Breadcrumb, Container } from "../../components/layout";
import { useAppState } from "../../context";

const { Option } = Select;

const UploadFile = () => {
  const {
    updateWeekWiseCSVFile,
    getAllWeeks,
    allWeeks,
    currentWeekData,
    getUploadLogHistory,
  } = useAppState("weekSetting");
  const { userData } = useAppState("auth");
  const [fileList, setFileList] = useState<any[]>([]);
  const [selectWeekData, setSelectWeekData] = useState<Array<any>>([]);
  const [selectedWeekId, setSelectedWeekId] = useState<any>({});
  const [isLoading, setIsLoading] = useState(false);
  const [isDisableWeek, setIsDisableWeek] = useState(false);
  const [logHistoryData, setLogHistoryData] = useState<any>([]);
  const [rowsPerPage] = useState(10);

  const [currentPage, setCurrentPage] = useState(1);

  const isUploadVisible = fileList.length === 0;

  const totalData = logHistoryData.length || 0;

  useEffect(() => {
    if (!allWeeks.length) {
      getAllWeeks();
    }
  }, []);

  useEffect(() => {
    if (allWeeks.length) {
      const filterData = allWeeks.map((item: any, index: any) => {
        return { ...item, id: parseInt(index), name: item.week };
      });

      const idsToRemove = userData.ignoreWeek;
      const weekFilterId = filterData.filter((item: any) => {
        return !idsToRemove.includes(item._id);
      });

      //console.log("filterData >>>", filterData);
      //console.log("currentWeekData >>>", currentWeekData);

      setSelectWeekData(weekFilterId);
      setSelectedWeekId(currentWeekData?._id || ""); // Set the first week as default selection
    }
  }, [allWeeks]);

  // Handle dropdown selection change
  const handleSelectChange = (value: string) => {
    setSelectedWeekId(value);
  };

  /* console.log("isLoading >>>", isLoading);
  console.log("isDisableWeek >>>", isDisableWeek); */

  const handleSubmit = async () => {
    if (fileList.length === 0) return;

    const formData = new FormData();

    //console.log("fileList[0].originFileObj >>>", fileList[0].originFileObj);

    ///return;
    formData.append("file", fileList[0].originFileObj);

    try {
      setIsLoading(true);

      /* await new Promise((resolve: any) => {
        setTimeout(() => {
          resolve();
        }, 5000);
      });
      setFileList([]);
      return;      
      */

      const formData = new FormData();
      formData.append("week", selectedWeekId);
      formData.append(
        "file",
        fileList.length === 0 ? "" : fileList[0].originFileObj,
      );
      /* console.log("fileList Length >>>", fileList.length);
      console.log("fileList >>>", fileList[0].originFileObj);
      console.log("selectedWeekId >>>", selectedWeekId);
      */
      const success = await updateWeekWiseCSVFile(formData);

      if (success) {
        await getAllWeeks();
        setFileList([]);
        checkSelectedWeekIsActive();
      }

      setIsLoading(false);
    } catch (error) {
      console.error("Failed to update week setting:", error);
      setIsLoading(false);
    }
  };

  const handleFileChange = ({ fileList }: any) => {
    setFileList(fileList.slice(-1)); // Allow only one file
  };

  const handleRemove = () => {
    setFileList([]);
  };

  /* Columns Start */
  const chapterMemberColumns = [
    {
      title: "From",
      dataIndex: "fromMemberName",
      align: "left",
      /* width: "5%", */
      key: "fromMemberName",
    },
    {
      title: "To - Slip Type",
      dataIndex: "activityTypes",
      key: "activityTypes",
      align: "left",
      render: (item: any) => {
        const rows = [
          ...(item?.oneToOne?.map((user: any) => ({
            name: user.userName,
            type: "One to One",
          })) || []),
          ...(item?.referrals?.map((user: any) => ({
            name: user.userName,
            type: "Referrals",
          })) || []),
        ];

        return (
          <>
            {rows.map((row: any, index: number) => (
              <div key={index}>
                {row.name} - {row.type}
              </div>
            ))}
          </>
        );
      },
    },
    /* {
      title: "To - Slip Type",
      dataIndex: "activityTypes",
      align: "left",
      key: "activityTypes",
      render: (item: any) => {
        const oneToOneUsers =
          item?.oneToOne?.map((user: any) => user.userName) || [];

        const referralUsers =
          item?.referrals?.map((user: any) => user.userName) || [];

        return [...oneToOneUsers, ...referralUsers].join(", ");
      },
    },
    {
      title: "Slip Type",
      dataIndex: "activityTypes",
      align: "left",
      key: "activityTypes",
      render: (item: any) => {
        const slipTypes = [];

        if (item?.oneToOne?.length > 0) {
          slipTypes.push("One to One");
        }

        if (item?.referrals?.length > 0) {
          slipTypes.push("Referrals");
        }

        return slipTypes.join(", ");
      },
    }, */
    {
      title: "Team Name",
      dataIndex: "teamName",
      align: "left",
      /* width: "20%", */
      key: "teamName",
    },
    {
      title: "Status",
      dataIndex: "status",
      align: "left",
      /* width: "20%", */
      key: "status",
      render: (item: any) => {
        return item ? "PASS" : "FAIL";
      },
    },
  ];
  /* Columns End */

  const checkSelectedWeekIsActive = () => {
    const filterData = allWeeks.filter((item: any) => {
      return item._id === selectedWeekId;
    });
    setIsDisableWeek(filterData.length > 0 ? filterData[0].isUpload : false);
  };

  const fetchUploadLogHistory = useCallback(async () => {
    //console.log("$$$ selectedWeekId <<<", selectedWeekId, currentWeekData);

    if (size(selectedWeekId) > 0) {
      const result = await getUploadLogHistory(selectedWeekId);
      //console.log("result >>>>", result);
      setLogHistoryData(result || []);
    }
  }, [selectedWeekId, currentWeekData]);

  useEffect(() => {
    if (size(selectedWeekId) > 0) {
      fetchUploadLogHistory();
    }

    checkSelectedWeekIsActive();
  }, [selectedWeekId, currentWeekData]);

  //console.log("### selectedWeekId <<<", selectedWeekId, currentWeekData);

  return (
    <Layout>
      <Breadcrumb title="Upload .CSV File" />

      <Container>
        {/* Dropdown for member selection */}
        <div className="mb-4">
          <Select
            // mode="multiple"
            disabled={isLoading}
            style={{ width: "100%" }}
            placeholder="Select Current Week"
            value={selectedWeekId}
            onChange={handleSelectChange}
            // maxTagCount={4}
            optionFilterProp="children"
          >
            {selectWeekData.map((weekDetail: any) => (
              <Option key={weekDetail._id} value={weekDetail._id}>
                {weekDetail.week}
              </Option>
            ))}
          </Select>
        </div>
        <div className="mb-6">
          <Upload
            fileList={fileList}
            onChange={handleFileChange}
            beforeUpload={() => false}
            showUploadList={false}
            multiple={false}
            accept=".csv"
            disabled={!isUploadVisible || isDisableWeek}
          >
            <button
              type="button"
              disabled={!isUploadVisible || isDisableWeek}
              className={`bg-[#00A48B] text-white font-bold py-2 px-5 rounded-full flex items-center gap-3
                ${
                  !isUploadVisible || isDisableWeek
                    ? "opacity-50 cursor-not-allowed"
                    : "cursor-pointer"
                }`}
            >
              <img
                src={allImgPaths.Upload_Icon}
                className="w-6 h-6"
                alt="Upload"
              />

              <span>Upload .CSV File</span>
            </button>
          </Upload>

          {/* Uploaded File */}
          {fileList.length > 0 && (
            <div className="mt-4 flex items-center justify-between border rounded-lg px-4 py-3 bg-gray-50">
              <div className="flex items-center gap-3">
                <img src={allImgPaths.Upload_Icon} className="w-5 h-5" alt="" />

                <span className="font-medium">{fileList[0].name}</span>
              </div>

              <Button
                danger
                type="text"
                icon={<DeleteOutlined />}
                disabled={isLoading || isDisableWeek}
                onClick={handleRemove}
              >
                Delete
              </Button>
            </div>
          )}
        </div>

        <Button
          type="primary"
          onClick={handleSubmit}
          disabled={fileList.length === 0 || isLoading || isDisableWeek}
        >
          Submit
        </Button>
        {isLoading && <h1 className="text-center">Loading...</h1>}
        <div className="mt-6">
          <div className="custom-card shadow-md border rounded-lg p-6 bg-white h-full">
            <h2 className="text-lg font-semibold text-center my-3">
              Uploaded Log History
            </h2>
            <CustomTable
              data={logHistoryData}
              columns={chapterMemberColumns}
              onSearch={() => setCurrentPage(1)}
              fetchData={fetchUploadLogHistory}
              totalData={totalData}
              currentPage={currentPage}
              rowsPerPage={rowsPerPage}
              paginationShow={false}
            />
          </div>
        </div>
      </Container>
    </Layout>
  );
};

export default UploadFile;
